var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var DualRowPackageWithDifferentPadGeneratorInteractionModel = require('../dualRowPackageWithDifferentPadGeneratorInteractionModel.js');
var PackageGeneratorInspectorConfig = require("../../packageGeneratorInspectorConfig.js");
var IpcImages = require("../../../../../shared/extensions/footprintGenerator/ipcImages/index.js");

var ToDpakPadGeneratorInteractionModel = function(parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams) {
    DualRowPackageWithDifferentPadGeneratorInteractionModel.call(this, parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams);
};

lib_core.inherit(ToDpakPadGeneratorInteractionModel, DualRowPackageWithDifferentPadGeneratorInteractionModel);
ToDpakPadGeneratorInteractionModel.$class = 'ToDpakPadGeneratorInteractionModel';

module.exports = ToDpakPadGeneratorInteractionModel;

ToDpakPadGeneratorInteractionModel.prototype.initialize = function() {
    var self = this;

    DualRowPackageWithDifferentPadGeneratorInteractionModel.prototype.initialize.call(this);

    this.oddPadWidthMin = this.shadow("oddPadWidthMin",
        function() {
            return self.data.oddPadWidthMin() / self.getUnitFactor();
        },
        function(value) {
            return self.data.oddPadWidthMin(parseFloat(value) * self.getUnitFactor());
        }, [
            self.data.oddPadWidthMin, this.userSettingsModel.distanceUnit
        ]
    );

    this.oddPadWidthMax = this.shadow("oddPadWidthMax",
        function() {
            return self.data.oddPadWidthMax() / self.getUnitFactor();
        },
        function(value) {
            return self.data.oddPadWidthMax(parseFloat(value) * self.getUnitFactor());
        }, [
            self.data.oddPadWidthMax, this.userSettingsModel.distanceUnit
        ]
    );

    this.extendedEdgeWidth = this.shadow("extendedEdgeWidth",
        function() {
            return self.data.extendedEdgeWidth() / self.getUnitFactor();
        },
        function(value) {
            value = parseFloat(value);
            return self.data.extendedEdgeWidth(value * self.getUnitFactor());
        }, [
            self.data.extendedEdgeWidth, this.userSettingsModel.distanceUnit
        ]
    );

    //show truncate option when total pin count including thermal pad is either 4 or 6 or 8
    this.showTruncatePinOption = this.shadow("showTruncatePinOption",
        function() {
            if(self.data.horizontalPadCount() === 4
                || self.data.horizontalPadCount() === 6
                || self.data.horizontalPadCount() === 8) {
                return true;
            }

            return false;
        },
        null,
        [
            self.data.horizontalPadCount
        ]
    );

    this.hasTruncatedPin = this.shadow("hasTruncatedPin",
        function() {
            return self.data.hasTruncatedPin();
        },
        function(value) {
            return self.data.hasTruncatedPin(value);
        },
        [
            self.data.hasTruncatedPin
        ]
    );
};

ToDpakPadGeneratorInteractionModel.prototype.getInspectorElementForPadCount = function() {
    return [PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('#Pins', '# Pins'), this.horizontalPadCount, [3, 4, 5, 6, 7, 8, 9, 10, 12, 16])];
};

ToDpakPadGeneratorInteractionModel.prototype.getInspectorElementForTruncateMiddlePin = function() {
    return [PackageGeneratorInspectorConfig.getCheckBox(this.LCLZ('truncateMiddlePin', 'Truncate Middle Pin'), this.hasTruncatedPin, this.showTruncatePinOption)];
};

ToDpakPadGeneratorInteractionModel.prototype.getInspectorElementForExtendedEdgeLength = function() {
    return [PackageGeneratorInspectorConfig.getValueFixedUnit('L1', this.LCLZ('extendedEdgeLength', 'Extended Edge Length'), this.extendedEdgeWidth, this.userSettingsModel.distanceUnit)];
};

ToDpakPadGeneratorInteractionModel.prototype.getInspectorElementForTerminalLength = function() {
    var normalTerminalLength = PackageGeneratorInspectorConfig.getMinMaxRow('L', this.LCLZ('terminalLength', 'Terminal Length'), false, this.padWidthMin, false, this.padWidthMax, this.userSettingsModel.distanceUnit);
    var tabLength = PackageGeneratorInspectorConfig.getMinMaxRow('E2', this.LCLZ('tabLength', 'Tab Length'), false, this.oddPadWidthMin, false, this.oddPadWidthMax, this.userSettingsModel.distanceUnit);

    return [normalTerminalLength, tabLength];
};

ToDpakPadGeneratorInteractionModel.prototype.getInspectorElementForTerminalWidth = function() {
    var normalTerminalWidth = PackageGeneratorInspectorConfig.getMinMaxRow('b', this.LCLZ('terminalWidth', 'Terminal Width'), false, this.padHeightMin, false, this.padHeightMax, this.userSettingsModel.distanceUnit);
    var tabWidth = PackageGeneratorInspectorConfig.getMinMaxRow('b1', this.LCLZ('tabWidth', 'Tab Width'), false, this.oddPadHeightMin, false, this.oddPadHeightMax, this.userSettingsModel.distanceUnit);

    return [normalTerminalWidth, tabWidth];
};

ToDpakPadGeneratorInteractionModel.prototype.getInspectorElements = function() {
    var imElements = [];

    //custom footprint settings
    if (this.withCustomFootprintParams() && this.showFootprintParams()) {
        imElements = imElements.concat(this.getInspectorElementForEnablingCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintImage(IpcImages.customFootprintToDpak));
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintNormalPadSettings());
        imElements = imElements.concat(this.getInspectorElementForOddPadLengthInCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForOddPadWidthInCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForPadSpan1InCustomFootprint());
    };
    imElements = imElements.concat(this.getInspectorElementForPadCount());
    imElements = imElements.concat(this.getInspectorElementForTruncateMiddlePin());
    imElements = imElements.concat(this.getInspectorElementForPadShape());
    imElements = imElements.concat(this.getInspectorElementForPadRoundness());
    imElements = imElements.concat(this.getInspectorElementForDensityLevel());
    imElements = imElements.concat(this.getInspectorElementForPitch());
    imElements = imElements.concat(this.getInspectorElementForExtendedEdgeLength());
    imElements = imElements.concat(this.getInspectorElementForLeadSpan());
    imElements = imElements.concat(this.getInspectorElementForTerminalLength());
    imElements = imElements.concat(this.getInspectorElementForTerminalWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyLength());
    imElements = imElements.concat(this.getInspectorElementForBodyWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyHeight());
    imElements = imElements.concat(this.getInspectorElementForMapping());
    imElements = imElements.concat(this.getInspectorElementForTolerance());

    this.inspectorElements.input_elements = imElements;
    return this.inspectorElements;
};